import { CreateMenuData, Menu, MenuService } from "@/client";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

function useCreateNavigation(
  mutationOptions?: UseMutationOptions<Menu, HttpError, CreateMenuData>,
) {
  return useMutation({
    mutationFn: MenuService.createMenu,
    ...mutationOptions,
  });
}

export { useCreateNavigation };
